import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/app/signalr/notification.service';
import FeaUtils from '../../FeaUtils';
import { FeaBaseProcessService } from './fea-base-process.service';
import { VectorResult } from '../../models/results/vector-result';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeaDLAService {

  constructor(
    private readonly feaBaseProcessService : FeaBaseProcessService,
    private readonly http: HttpClient,
    private readonly notificationService: NotificationService,
  ) {
  }

  public async getResult(vectorName: string) : Promise<any> {
    const baseRequest = await this.feaBaseProcessService.getBaseProcessRequest();
    const request = {
      ...baseRequest,
      ResultType: "Envelope",
      //OutputSet: "1", // While we cannot choose the output, choose the latest
      Vector: vectorName
    };

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }),
      responseType: 'json' as 'json'
    };

    try {
      const resultData = await firstValueFrom(this.http.post(environment.API_FEA + `DLA/GetResult`, request, options));
      const vectorResult = new VectorResult(resultData);

      const csvText = await firstValueFrom(this.http.get(vectorResult.ResultUrl, { responseType: 'text' as 'text' }));
      var valuesPerElement = FeaUtils.ExtractValuesFromCSV(csvText);
      var title = `DLA Unit Check\nOutput Vector: ${vectorName.replace("/", ":")} Envelope`;

      return {
        valuesPerElement: valuesPerElement,
        title: title,
        processResult: vectorResult
      };
    }
    catch (err) {
      console.log(err);
      this.notificationService.addFailedNotification("Failed to get or parse DLA result");
      return null; // Indicate failure
    }
  }
}
